import styled from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { themeGet } from 'styled-system';

export const Slides = styled(Slider)`
  margin: 2rem 0;

  .slick-track {
    display: flex;
  }

  .slick-arrow {
    position: absolute;
    z-index: 999;
    width: 5%;
    height: 100%;
    display: flex;
    justify-content: center;

    &.slick-prev {
      background: linear-gradient(
        270deg,
        transparent,
        rgba(0, 0, 0, 0.4),
        #000
      );
      left: 0;
    }

    &.slick-next {
      background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.4), #000);
      right: 0;
    }

    &::before {
      content: '';
      width: 40px;
      height: 40px;
      display: inline-block;
      background: 50% / contain
        url(https://s3.eu-central-1.amazonaws.com/nov-assets/fe-assets/arrow.svg)
        no-repeat;
    }

    &.slick-prev::before {
      transform: rotate(180deg);
    }
  }
`;

export const Slide = styled.div`
  width: auto;
  height: 70vmin;
  padding: 0 0.5rem;
  box-sizing: border-box;
`;

export const Image = styled.picture`
  width: auto;
  height: 70vmin;

  img {
    width: auto;
    height: 100%;
    object-fit: contain;
  }
`;

export const Info = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  padding: 0 5rem;
  box-sizing: border-box;

  h3 {
    font-style: italic;
    font-size: 2.6rem;
    line-height: 1.2em;
    text-align: center;
  }

  h4 {
    font-size: 1.3rem;
    margin: 1em 0;
    font-family: ${themeGet('fonts.secondary')};
    color: ${themeGet('color.4')};
    text-align: center;
  }

  hr {
    width: 50px;
  }

  p {
    text-align: center;
    font-family: ${themeGet('fonts.secondary')};
  }
`;

export const Share = styled.div`
  background-color: ${themeGet('color.5')};
  height: 100%;
  padding: 5%;
  box-sizing: border-box;
`;
